import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
    getTypeOperationFields() {
        return {
            model: 'type_operation',
            label: 'Types Operation',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'id_license', label: 'id_license', type: 'number', sortable: true, required: true },
                { key: 'status', label: 'status', type: 'boolean', sortable: true, required: true },
            ]
        }
    },
}

export const actions = {
    async fetchOperationTypes(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/masters/operation_types/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsOperationTypes(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/masters/operation_types/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createOperationTypes(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/masters/operation_types/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updateOperationTypes(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/masters/operation_types/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async deleteOperationTypes(context, id) {
        return axios
            .delete(`${serverUrl}/api/v1/masters/operation_types/${id}/`)
            .then((response) => {
                return response.data;
            })
    }
}